/* Velunaris Home: Einblenden, Zaehler, Laerm-Umschalter und Groessen-Finder der Startseite.
   Ohne JS bleibt alles sichtbar (velunaris-home.css blendet .vc-in nur mit html.js aus). */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Intro-Schleier aus velunaris-atelier.js: dort ist noch die alte Mondform hinterlegt. Hier auf die Logo-Form umstellen. */
  var MOON = 'M24.36 .54A30 30 0 1 0 55.03 46.54A28 28 0 1 1 24.36 .54Z';
  document.querySelectorAll('.vxa-veil svg').forEach(function (svg) {
    svg.setAttribute('viewBox', '0 0 60 60');
    svg.querySelectorAll('path').forEach(function (p) { p.setAttribute('d', MOON); });
  });

  function countUp(el) {
    var raw = el.getAttribute('data-vc-count');
    if (!/^\d+$/.test(raw) || reduce) return;
    var target = parseInt(raw, 10);
    var start = null;
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / 1400, 1);
      el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  var items = document.querySelectorAll('.vc-in');
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        e.target.querySelectorAll('[data-vc-count]').forEach(countUp);
        io.unobserve(e.target);
      });
    }, { threshold: 0.2 });
    items.forEach(function (el) { io.observe(el); });
  }

  document.querySelectorAll('.vc-scene').forEach(function (scene) {
    scene.querySelectorAll('[data-vc-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var calm = btn.getAttribute('data-vc-mode') === 'on';
        scene.classList.toggle('is-calm', calm);
        scene.querySelectorAll('[data-vc-mode]').forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active);
        });
        scene.querySelector('[data-off]').hidden = calm;
        scene.querySelector('[data-on]').hidden = !calm;
      });
    });
  });

  document.querySelectorAll('[data-vc-sizes]').forEach(function (picker) {
    var label = picker.querySelector('[data-vc-label]');
    function select(size) {
      picker.querySelectorAll('[data-vc-size]').forEach(function (b) {
        var active = b.getAttribute('data-vc-size') === size;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active);
      });
      picker.querySelectorAll('.vc-ring').forEach(function (r) {
        r.classList.toggle('is-active', r.getAttribute('data-size') === size);
      });
      label.textContent = size.toUpperCase();
    }
    picker.querySelectorAll('[data-vc-size]').forEach(function (b) {
      b.addEventListener('click', function () { select(b.getAttribute('data-vc-size')); });
    });
    select('m');
  });
})();
